// src/OcupacaoMapa.js

import React, { useState, useEffect } from 'react';
// --- CORREÇÃO APLICADA AQUI: Importa novas funções e componentes ---
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';
import { 
  Box, Typography, Paper, CircularProgress, Tooltip, TextField,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton
} from '@mui/material';
import { blue, green, red, yellow, orange, grey } from '@mui/material/colors';
import SearchIcon from '@mui/icons-material/Search'; // --- NOVO ÍCONE ---
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { toast } from 'react-toastify';

// Imports para o seletor de data
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import useReservasStore from './store/reservasStore';
import DetalhesReservaModal from './DetalhesReservaModal';
import ReservaModal from './ReservaModal';
import { doc, deleteDoc } from 'firebase/firestore';


const LegendaCores = () => (
  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, my: 2, justifyContent: 'center' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 15, height: 15, backgroundColor: blue[500] }} /><Typography variant="caption">Hospedado</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 15, height: 15, backgroundColor: green[500] }} /><Typography variant="caption">Pago Total</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 15, height: 15, backgroundColor: red[500] }} /><Typography variant="caption">Pago Sinal</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 15, height: 15, backgroundColor: yellow[700] }} /><Typography variant="caption">Aguardando Pag.</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}><Box sx={{ width: 15, height: 15, backgroundColor: orange[700] }} /><Typography variant="caption">Em Limpeza</Typography></Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box sx={{ width: 15, height: 15, backgroundColor: grey[400], 
            backgroundImage: 'linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa), linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa)',
            backgroundSize: '6px 6px',
            backgroundPosition: '0 0, 3px 3px'
        }} />
        <Typography variant="caption">Manutenção</Typography>
    </Box>
  </Box>
);

const OcupacaoMapa = () => {
  dayjs.locale('pt-br');
  const { chales, reservas, loading: loadingStore, fetchInitialData } = useReservasStore();
  const [dataExibida, setDataExibida] = useState(dayjs());
  
  const [manutencoes, setManutencoes] = useState([]);
  const [loadingLocal, setLoadingLocal] = useState(false);
  
  const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
  const [reservaSelecionada, setReservaSelecionada] = useState(null);
  const [modalReservaAberto, setModalReservaAberto] = useState(false);
  const [chaleParaNovaReserva, setChaleParaNovaReserva] = useState(null);
  const [dataParaNovaReserva, setDataParaNovaReserva] = useState(null);
  const [reservaParaEditar, setReservaParaEditar] = useState(null);
  const [termoBuscaVoucher, setTermoBuscaVoucher] = useState('');


  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  useEffect(() => {
    const fetchManutencoes = async () => {
        if (!dataExibida) return;
        setLoadingLocal(true);
        try {
            const inicioMes = dataExibida.startOf('month').format('YYYY-MM-DD');
            const fimMes = dataExibida.endOf('month').format('YYYY-MM-DD');
            
            const manutencoesRef = collection(db, 'manutencoes');
            const q = query(
                manutencoesRef,
                where('dataInicio', '<=', fimMes),
                where('dataFim', '>=', inicioMes)
            );
            const querySnapshot = await getDocs(q);
            const manutencoesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setManutencoes(manutencoesData);
        } catch (error) {
            console.error("Erro ao buscar manutenções: ", error);
            toast.error("Erro ao carregar os dados de manutenção.");
        } finally {
            setLoadingLocal(false);
        }
    };
    fetchManutencoes();
  }, [dataExibida]);


  const handleBuscarVoucher = async () => {
    if (!termoBuscaVoucher.trim()) {
        toast.info('Por favor, digite um código de voucher para buscar.');
        return;
    }
    try {
        const reservasRef = collection(db, 'reservas');
        const q = query(reservasRef, where('codigoVoucher', '==', termoBuscaVoucher.trim().toUpperCase()));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
            toast.error('Nenhuma reserva encontrada com este código de voucher.');
        } else {
            const reservaEncontrada = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
            setReservaSelecionada(reservaEncontrada);
            setModalDetalhesAberto(true);
            setTermoBuscaVoucher('');
        }
    } catch (error) {
        toast.error('Ocorreu um erro ao buscar a reserva.');
        console.error("Erro ao buscar voucher:", error);
    }
  };

  const abrirModalDetalhes = (reserva) => { setReservaSelecionada(reserva); setModalDetalhesAberto(true); };
  const fecharModalDetalhes = () => { setModalDetalhesAberto(false); setReservaSelecionada(null); };
  const abrirModalNovaReserva = (chale, data) => { setChaleParaNovaReserva(chale); setDataParaNovaReserva(data); setModalReservaAberto(true); };
  const fecharModalReserva = () => { setModalReservaAberto(false); setChaleParaNovaReserva(null); setReservaParaEditar(null); fetchInitialData(); };
  const handleEditarReserva = (reserva) => { fecharModalDetalhes(); setReservaParaEditar(reserva); setModalReservaAberto(true); };

  const handleExcluirReserva = async (reservaId) => {
    try {
        await deleteDoc(doc(db, "reservas", reservaId));
        toast.success("Reserva excluída com sucesso!");
        fecharModalDetalhes();
        fetchInitialData();
    } catch (error) {
        toast.error("Erro ao excluir reserva.");
        console.error("Erro ao excluir reserva:", error);
    }
  };

  const diasDoMes = Array.from({ length: dataExibida.daysInMonth() }, (_, i) => dataExibida.date(i + 1));
  const diasDaSemana = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB'];

  const getCorDaReserva = (reserva) => {
    if (reserva.statusReserva === 'Hospedado') return blue[500];
    const valorTotal = reserva.valorTotal || 0;
    const totalPago = (reserva.adiantamento?.valor || 0) + (reserva.pagamentoRestante?.valor || 0);
    const saldoDevedor = valorTotal - (reserva.desconto || 0) - totalPago;
    if (saldoDevedor <= 0) return green[500];
    if (reserva.adiantamento?.valor > 0) return red[500];
    return yellow[700];
  };

  const isLoading = loadingStore || loadingLocal;

  if (isLoading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}><CircularProgress /></Box>;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Paper sx={{ p: 2, m: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" fontWeight={600}>Mapa de Ocupação</Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
            <DatePicker
              views={['year', 'month']}
              label="Selecione o Mês"
              value={dataExibida}
              onChange={(novaData) => setDataExibida(novaData || dayjs())}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField
                    label="Buscar por Voucher..."
                    variant="outlined"
                    size="small"
                    value={termoBuscaVoucher}
                    onChange={(e) => setTermoBuscaVoucher(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleBuscarVoucher()}
                    sx={{ minWidth: '250px' }}
                />
                <Tooltip title="Buscar">
                    <IconButton color="primary" onClick={handleBuscarVoucher}>
                        <SearchIcon />
                    </IconButton>
                </Tooltip>
            </Box>
          </Box>
          <LegendaCores />
        </Box>
        
        <TableContainer sx={{ maxHeight: '70vh' }}>
          <Table stickyHeader size="small" sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', width: '120px', position: 'sticky', left: 0, zIndex: 10, bgcolor: 'background.paper' }}>Chalé</TableCell>
                {diasDoMes.map(dia => (
                  <TableCell key={dia.format('DD')} align="center" sx={{ fontWeight: 'bold', p: '6px 2px', width: '40px' }}>
                    <Typography variant="caption">{diasDaSemana[dia.day()]}</Typography><br/>
                    {dia.format('DD')}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(chales || []).map(chale => {
                const reservasDoChale = (reservas || []).filter(r => r.chaletId === chale.id);
                const manutencoesDoChale = (manutencoes || []).filter(m => m.chaleNumero === chale.numero);

                let diaAtual = 1;
                const celulas = [];

                while (diaAtual <= dataExibida.daysInMonth()) {
                  const dataCompleta = dataExibida.date(diaAtual).format('YYYY-MM-DD');
                  const reservaDoDia = reservasDoChale.find(r => dataCompleta >= r.dataCheckin && dataCompleta < r.dataCheckout);
                  const manutencaoDoDia = manutencoesDoChale.find(m => dataCompleta >= m.dataInicio && dataCompleta <= m.dataFim);

                  if (reservaDoDia) {
                    const inicio = dayjs(reservaDoDia.dataCheckin).isBefore(dataExibida.startOf('month')) ? dataExibida.startOf('month') : dayjs(reservaDoDia.dataCheckin);
                    
                    // --- CORREÇÃO DA REGRESSÃO APLICADA AQUI ---
                    // A lógica de cálculo da duração da faixa visual foi restaurada para incluir o dia do check-out.
                    const fimReserva = dayjs(reservaDoDia.dataCheckout);
                    const fimVisual = fimReserva.isAfter(dataExibida.endOf('month')) ? dataExibida.endOf('month') : fimReserva;

                    let duracao;
                    if (fimVisual.month() > inicio.month() || fimVisual.year() > inicio.year()) {
                        // A reserva estende-se para o próximo mês, então a barra vai até ao fim do mês atual.
                        duracao = dataExibida.daysInMonth() - inicio.date() + 1;
                    } else {
                        // A reserva termina no mês atual. O cálculo `+ 1` torna a data final inclusiva.
                        duracao = fimVisual.date() - inicio.date() + 1;
                    }
                    
                    celulas.push(
                      <TableCell
                        key={`reserva-${reservaDoDia.id}`}
                        colSpan={duracao === 0 ? 1 : duracao}
                        sx={{
                          bgcolor: getCorDaReserva(reservaDoDia), color: '#fff', textAlign: 'center', cursor: 'pointer',
                          p: '4px', borderLeft: '1px solid #fff', borderRight: '1px solid #fff',
                          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                        }}
                        onClick={() => abrirModalDetalhes(reservaDoDia)}
                      >
                        <Tooltip title={reservaDoDia.hospedeNome}><Typography variant="caption" fontWeight="bold">{reservaDoDia.hospedeNome}</Typography></Tooltip>
                      </TableCell>
                    );
                    diaAtual += (duracao === 0 ? 1 : duracao);
                  } else if (manutencaoDoDia) {
                    const inicio = dayjs(manutencaoDoDia.dataInicio).isBefore(dataExibida.startOf('month')) ? dataExibida.startOf('month') : dayjs(manutencaoDoDia.dataInicio);
                    const fim = dayjs(manutencaoDoDia.dataFim).isAfter(dataExibida.endOf('month')) ? dataExibida.endOf('month') : dayjs(manutencaoDoDia.dataFim);
                    let duracao = fim.diff(inicio, 'day') + 1;
                    duracao = Math.min(duracao, dataExibida.daysInMonth() - inicio.date() + 1);
                    
                    celulas.push(
                        <TableCell
                          key={`manut-${manutencaoDoDia.id}`}
                          colSpan={duracao}
                          sx={{
                            bgcolor: grey[400],
                            backgroundImage: 'linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa), linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa)',
                            backgroundSize: '6px 6px',
                            backgroundPosition: '0 0, 3px 3px',
                            color: grey[800], textAlign: 'center', p: '4px',
                            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                          }}
                        >
                           <Tooltip title={`Manutenção: ${manutencaoDoDia.motivo}`}>
                                <Typography variant="caption" fontWeight="bold">MANUTENÇÃO</Typography>
                           </Tooltip>
                        </TableCell>
                    );
                    diaAtual += duracao;
                  } else {
                    const chaleStatus = chale.status;
                    const cor = chaleStatus === 'Em Limpeza' ? orange[100] : 'transparent';
                    const diaDaCelula = diaAtual; 

                    celulas.push(
                      <TableCell
                        key={`vazio-${diaAtual}`}
                        sx={{ cursor: 'pointer', '&:hover': { bgcolor: '#f0f0f0' }, bgcolor: cor, p: '4px' }}
                        onClick={() => abrirModalNovaReserva(chale, dataExibida.date(diaDaCelula).format('YYYY-MM-DD'))}
                      />
                    );
                    diaAtual++;
                  }
                }

                return (
                  <TableRow key={chale.id}>
                    <TableCell sx={{ fontWeight: 'bold', position: 'sticky', left: 0, zIndex: 10, bgcolor: 'background.paper' }}>{chale.nome}</TableCell>
                    {celulas}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        {modalDetalhesAberto && (
          <DetalhesReservaModal
            reserva={reservaSelecionada}
            onClose={fecharModalDetalhes}
            onExcluir={handleExcluirReserva}
            onEditar={handleEditarReserva}
          />
        )}

        {modalReservaAberto && (
          <ReservaModal
            chale={reservaParaEditar ? chales.find(c => c.id === reservaParaEditar.chaletId) : chaleParaNovaReserva}
            onClose={fecharModalReserva}
            reservaParaEditar={reservaParaEditar}
            checkinPadrao={dataParaNovaReserva}
          />
        )}
      </Paper>
    </LocalizationProvider>
  );
};

export default OcupacaoMapa;

